// After changing this file, run `npx uglify-js .\assets\collection.js -o .\assets\collection.min.js`
// Otherwise the changes won't be applied
// https://www.npmjs.com/package/uglify-js

// The cursor of the last product retrieved, so we can load the correct products on subsequent clicks
var lastCursor = null;

// Determines if this is the first load more call or if we have loaded products through js during the current page session
var isFirstLoadMore = true;

// Hold the state of if there is a next page to be loaded. This will determine the visibility of the load more button
var hasNextPage = true;

var filterDropDownOpen = false;

// Define the query to be used when we load more products/ apply filters
const QUERY = `
query getProducts($first: Int, $after: String, $handle: String, $filters: [ProductFilter!], $sortKey: ProductCollectionSortKeys, $reverse: Boolean) {
    collection(handle: $handle) {
        products(first: $first, after: $after, filters: $filters, sortKey: $sortKey, reverse: $reverse) {
            edges {
                cursor
                node {
                    title
                    productType
                    availableForSale
                    onlineStoreUrl
                    handle
                    variants(first: 1) { 
                        edges {
                            node {
                                priceV2 {
                                    amount
                                }
                                compareAtPriceV2 {
                                    amount
                                }
                            }
                        }
                    }
                    images(first: 4) {
                        edges {
                            node {
                                originalSrc
                                altText
                            }
                        }
                    }
                    metafield(namespace: "global", key: "dimensions_attributes") {
                        namespace
                        key
                        value
                    }
                }
            }
            pageInfo {
                hasNextPage
            }
        }
    }
}`;

// Get scaled values
function getParsed(currentFrom, currentTo, scale = 1) {
    const from = parseFloat(currentFrom.value) / scale;
    const to = parseFloat(currentTo.value) / scale;
    return [from, to];
}

// Set the color of the inner range between the range thumbs
function fillSlider(from, to, controlSlider, scale = 1) {

    const rangeDistance = (to.max - to.min) / scale;
    const fromPosition = (from.value - to.min) / scale;
    const toPosition = (to.value - to.min) / scale;
    controlSlider.style.background = `linear-gradient(
        to right,
        ${sliderColor} 0%,
        ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
        ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
        ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
        ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
        ${sliderColor} 100%)`;
}

// Update teh z-index of the slider to always show the colored one on top
function setToggleAccessible(currentTarget, toSlider) {
    if (Number(currentTarget.value) <= 0) {
        toSlider.style.zIndex = 2;
    } else {
        toSlider.style.zIndex = 0;
    }
}

// Clamps a value between min, max, and zero 
function clamp(value, min, max) {
    let clamp = Math.min(Math.max(value, min), max);
    return clamp < 0 ? 0 : clamp;
}

// Control the number input for the from slider
function controlFromInput(fromInput, toInput, fromSlider, toSlider, scale) {
    let from = parseFloat(fromInput.value);
    let to = parseFloat(toInput.value);
    const max = toSlider.max / scale;
    const min = toSlider.min / scale;

    from = clamp(from, min, max);
    to = clamp(to, min, max);

    if (from > to) {
        fromSlider.value = to * scale;
        fromInput.value = to;
    } else {
        fromSlider.value = from * scale;
    }
    fillSlider(fromInput, toInput, toSlider);
}

// Control the number input for the to slider
function controlToInput(fromInput, toInput, fromSlider, toSlider, scale) {
    let from = parseFloat(fromInput.value);
    let to = parseFloat(toInput.value);
    const max = toSlider.max / scale;
    const min = toSlider.min / scale;

    from = clamp(from, min, max);
    to = clamp(to, min, max);

    setToggleAccessible(toInput, toSlider);
    if (from <= to) {
        toSlider.value = to * scale;
        toInput.value = to;
    } else {
        toInput.value = from;
        toSlider.value = from * scale;
    }
    fillSlider(fromInput, toInput, toSlider);
}

// Control the slider input for the from slider
function controlFromSlider(fromSlider, toSlider, fromInput, scale) {
    const [from, to] = getParsed(fromSlider, toSlider, scale);
    fillSlider(fromSlider, toSlider, toSlider, scale);
    if (from > to) {
        fromSlider.value = to * scale;
        fromInput.value = to;
    } else {
        fromInput.value = from;
    }
}

// Control the slider input for the to slider
function controlToSlider(fromSlider, toSlider, toInput, scale) {
    const [from, to] = getParsed(fromSlider, toSlider, scale);
    fillSlider(fromSlider, toSlider, toSlider, scale);
    setToggleAccessible(toSlider, toSlider);
    if (from <= to) {
        toSlider.value = to * scale;
        toInput.value = to;
    } else {
        toInput.value = from;
        toSlider.value = from * scale;
    }
}

// Initialize the sliders 
function initializeSlider(sliderContainer) {
    const fromSlider = sliderContainer.querySelector('.fromSlider');
    const toSlider = sliderContainer.querySelector('.toSlider');
    const fromInput = sliderContainer.querySelector('.fromInput');
    const toInput = sliderContainer.querySelector('.toInput');
    const scale = 100;

    fillSlider(fromSlider, toSlider, toSlider, scale);
    setToggleAccessible(toSlider, toSlider);

    fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput, scale);
    toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput, scale);

    fromInput.onchange = () => controlFromInput(fromInput, toInput, fromSlider, toSlider, scale);
    toInput.onchange = () => controlToInput(fromInput, toInput, fromSlider, toSlider, scale);
}
// Add/Remove a product to/from compare 
function toggleCompare(element) {
    ($ => {
        var $element = $(element);

        var compareProducts = [];
        if (localStorage.getItem('compare_products')) {
            compareProducts = JSON.parse(localStorage.getItem("compare_products"));
        }

        var productHandle = $element.data('product-handle');
        var productInCompare = compareProducts.includes(productHandle);

        if (compareProducts.length >= 4 && !productInCompare) {
            alert('You can\'t add more than 4 products to compare');
            return;
        }

        if ($element.data('is-compared') === false) {
            if (!productInCompare) {
                compareProducts.push(productHandle);

                // Show popup
                var popup = $('#compare_added_popup');
                if (popup.length > 0) {
                    var productContainer = $element.closest('.card--holder');
                    var title = productContainer.find('.card__title').text();
                    var imageContainer = productContainer.find('.card__img');
                    var imageSrc = imageContainer.find('img').data('default-src');

                    popup.find('.product-title').text(title);
                    popup.find('.product-image').attr('src', imageSrc);
                    popup.css('opacity', '1');
                    popup.css('left', '15px');
                }
            }

            $element.data('is-compared', true);
            $element.addClass('product-compare__button-added');

        } else {
            if (productInCompare) {
                compareProducts = compareProducts.filter(handle => handle != productHandle);
            }

            $element.data('is-compared', false);
            $element.removeClass('product-compare__button-added');
        }

        localStorage.setItem('compare_products', JSON.stringify(compareProducts));
    })(jQuery);
}

// Function to get URL parameters
function getURLParams() {
    const url = new URL(window.location.href);
    const params = Object.fromEntries(url.searchParams.entries());

    // Decode rangeFilters parameter into an object
    if (params.rangeFilters) {
        params.rangeFilters = params.rangeFilters.split(',').reduce((acc, filter) => {
            const [key, value] = filter.split(':');
            acc[key] = value;
            return acc;
        }, {});
    }

    // Decode listFilters parameter into an object of arrays
    if (params.listFilters) {
        params.listFilters = params.listFilters.split(';').reduce((acc, filter) => {
            const [key, values] = filter.split(':');
            acc[key] = values.split(',');
            return acc;
        }, {});
    }

    return params;
}

// Function to update URL parameters
function updateURLParams(params) {
    const url = new URL(window.location.href);

    // Convert rangeFilters object into a string
    if (params.rangeFilters) {
        params.rangeFilters = Object.entries(params.rangeFilters)
            .filter(([key]) => key)
            .map(([key, value]) => `${key}:${value}`)
            .join(',');
    }

    // Convert listFilters object of arrays into a string
    if (params.listFilters) {
        params.listFilters = Object.entries(params.listFilters)
            .filter(([key]) => key)
            .map(([key, values]) => `${key}:${values.join(',')}`)
            .join(';');
    }

    if (Object.entries(params).length === 0) {
        url.search = '';
    } else {
        for (const [key, value] of Object.entries(params)) {
            if (value && value != '') {
                url.searchParams.set(key, value);
            } else {
                url.searchParams.delete(key);
            }

        }
    }

    window.history.replaceState({}, '', url);
}

function resetFilterValues() {
    var mobileContentContainers = document.querySelectorAll('.custom-mobile-accordion-content');
    var filters = Array.from(mobileContentContainers);

    filters.forEach((dropDown) => {

        if (dropDown.dataset.type == 'rangeFilter') {
            // Reset the input values
            let fromInput = dropDown.querySelector('.fromInput');
            let toInput = dropDown.querySelector('.toInput');
            if (fromInput && toInput) {
                fromInput.value = fromInput.getAttribute('min') || 0;
                toInput.value = toInput.getAttribute('max') || 100;
            }

            // Reset the slider values
            let fromSlider = dropDown.querySelector('.fromSlider');
            let toSlider = dropDown.querySelector('.toSlider');
            if (fromSlider && toSlider) {
                fromSlider.value = fromSlider.getAttribute('min') || '';
                toSlider.value = toSlider.getAttribute('max') || '';
            }

            fillSlider(fromSlider, toSlider, toSlider);
        } else if (dropDown.dataset.type == 'listFilter') {
            let checkboxes = dropDown.querySelectorAll('.checkbox-container input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });
        }

    });

    var mobileFilterControls = document.querySelectorAll('.mobile-accordion-filters-controls');
    mobileFilterControls.forEach(control => {
        control.style.display = 'none';
    });

}

function setFilterValues(params) {
    var rangeFilters = params['rangeFilters'];
    var listFilters = params['listFilters'];

    if (rangeFilters && Object.keys(rangeFilters).length > 0) {
        Object.keys(rangeFilters).forEach((key) => {
            var sanatizedKey = key.split('-')[0];
            var filter = document.getElementById('filter-container-mobile-' + sanatizedKey);
            var [min, max] = rangeFilters[key].split('-');
            if (filter && min && max) {
                // Set the input values 
                let fromInput = filter.querySelector('.fromInput');
                let toInput = filter.querySelector('.toInput');
                if (fromInput && toInput) {
                    fromInput.value = min || fromInput.getAttribute('min') || 0;
                    toInput.value = max || toInput.getAttribute('max') || 100;
                }

                // Set the slider values
                let fromSlider = filter.querySelector('.fromSlider');
                let toSlider = filter.querySelector('.toSlider');
                if (fromSlider && toSlider) {
                    fromSlider.value = (min * 100) || fromSlider.getAttribute('min') || '';
                    toSlider.value = (max * 100) || toSlider.getAttribute('max') || '';
                }

                fillSlider(fromSlider, toSlider, toSlider);
            }
        });
    }

    if (listFilters && Object.keys(listFilters).length > 0) {
        Object.keys(listFilters).forEach((key) => {
            var filter = document.getElementById('filter-container-mobile-' + key);
            if (filter) {
                const filterValues = listFilters[key];
                filterValues.forEach(value => {
                    var valueId = '#mobile-' + value;
                    var valueElement = filter.querySelector(valueId);
                    if (valueElement) {
                        valueElement.checked = true;
                    }
                });
            }
        });
    }
}

function createFilterTags(params) {
    var rangeFilters = params['rangeFilters'];
    var listFilters = params['listFilters'];

    // Create tags for range filters
    if (rangeFilters && Object.keys(rangeFilters).length > 0) {
        var processedKeys = [];
        Object.keys(rangeFilters).forEach((key) => {
            var alreadyProcessed = false;
            processedKeys.forEach((pKey) => {
                if (key.includes(pKey)) {
                    alreadyProcessed = true;
                }
            });

            if (!alreadyProcessed) {
                var content = rangeFilters[key].replace('-', ' - ');
                createMobileTag(key, content, 'rangeFilter');
            }

            processedKeys.push(key);
        });
    }

    // Create tags for list filters
    if (listFilters && Object.keys(listFilters).length > 0) {
        Object.keys(listFilters).forEach((key) => {
            var listFiltersString = listFilters[key].join(', ');
            createMobileTag(key, listFiltersString, 'listFilter');
        });
    }
}

function createMobileTag(key, content, filterType) {

    var filterKey = key;
    if (filterType == 'rangeFilter') {
        var splitKey = key.split('-');
        splitKey.pop();
        filterKey = splitKey.join('-');
    }

    var filterContainer = document.querySelector('#filter-container-mobile-' + filterKey);
    if (filterContainer) {
        var accordionItem = filterContainer.closest('.custom-mobile-accordion-item');

        if (accordionItem) {
            var filterControls = accordionItem.querySelector('.mobile-accordion-filters-controls');
            if (filterControls) {
                filterControls.style.display = 'flex';
                var tagContainer = accordionItem.querySelector('.mobile-accordion-applied-filters');
                if (tagContainer) {
                    tagContainer.innerHTML = content;
                }
            }
        }
    }
}

function clearMobileFilter(event) {
    event.preventDefault();
    var params = getURLParams();
    var button = event.target;

    var filterControls = button.closest('.mobile-accordion-filters-controls');
    if (filterControls) {
        filterControls.style.display = 'none';
        var accordionItem = filterControls.closest('.custom-mobile-accordion-item');
        if (accordionItem) {
            var filterButton = accordionItem.querySelector('.filter-apply-mobile-button');
            if (filterButton) {
                var filterKey = filterButton.dataset.filterKey;

                if (button.dataset.type == 'rangeFilter') {
                    var step = filterButton.dataset.filterStep;
                    filterKey = filterKey + '-' + step;

                    if (params['rangeFilters'][filterKey]) {
                        delete params['rangeFilters'][filterKey];

                        let fromInput = accordionItem.querySelector('.fromInput');
                        let toInput = accordionItem.querySelector('.toInput');
                        if (fromInput && toInput) {
                            fromInput.value = fromInput.getAttribute('min') || 0;
                            toInput.value = toInput.getAttribute('max') || 100;
                        }

                        // Reset the slider velues
                        let fromSlider = accordionItem.querySelector('.fromSlider');
                        let toSlider = accordionItem.querySelector('.toSlider');
                        if (fromSlider && toSlider) {
                            fromSlider.value = fromSlider.getAttribute('min') || '';
                            toSlider.value = toSlider.getAttribute('max') || '';
                        }

                        fillSlider(fromSlider, toSlider, toSlider);
                    }
                } else if (button.dataset.type == 'listFilter') {
                    if (params['listFilters'][filterKey]) {
                        delete params['listFilters'][filterKey];

                        listForm = accordionItem.querySelector('.list-filter');

                        if (listForm) {
                            var checkboxes = listForm.querySelectorAll('input[type="checkbox"]');

                            checkboxes.forEach(checkbox => {
                                checkbox.checked = false;
                            })
                        }
                    }
                }
            }
        }
    }

    updateURLParams(params);
    applyFilters(event);
}

function removeFilter(event) {
    var button = event.target;
    var buttonId = button.id;
    var params = getURLParams();

    if (button.dataset.type == 'rangeFilter') {
        var filterKey = buttonId.replace('-desktop', '');
        if (params['rangeFilters']) {
            delete params['rangeFilters'][filterKey];

            var splitKey = filterKey.split('-');
            splitKey.pop();
            var adjustedFilterKey = splitKey.join('-');

            var sliderContainers = document.querySelectorAll('.slider-container');
            sliderContainers.forEach(function (container) {
                var filterKey = container.dataset.filterKey;
                if (filterKey) {
                    if (filterKey.includes(adjustedFilterKey)) {
                        let fromInput = container.querySelector('.fromInput');
                        let toInput = container.querySelector('.toInput');
                        if (fromInput && toInput) {
                            fromInput.value = fromInput.getAttribute('min') || 0;
                            toInput.value = toInput.getAttribute('max') || 100;
                        }

                        // Reset the slider velues
                        let fromSlider = container.querySelector('.fromSlider');
                        let toSlider = container.querySelector('.toSlider');
                        if (fromSlider && toSlider) {
                            fromSlider.value = fromSlider.getAttribute('min') || '';
                            toSlider.value = toSlider.getAttribute('max') || '';
                        }

                        fillSlider(fromSlider, toSlider, toSlider);
                    }
                }
            });
        }
    } else if (button.dataset.type == 'listFilter') {
        var filterKey = buttonId.replace('-desktop', '');
        var splitKey = filterKey.split('-');
        var filterType = splitKey[0];
        var filterValue = splitKey.slice(1).join('-');

        var filterValues = params['listFilters'][filterType];
        if (filterValues) {
            var valueIndex = filterValues.indexOf(filterValue);
            if (valueIndex > -1) {
                filterValues.splice(valueIndex, 1);
            }

            if (filterValues.length === 0) {
                delete params['listFilters'][filterType];
            }

            var filter = document.getElementById(filterValue);
            if(filter) {
                filter.checked = false;
            }
        }
    }
    button.remove();

    updateURLParams(params);
    applyFilters();

}

// Clears all filter tags
function clearFilterTags() {
    const filterRows = document.querySelectorAll('.mobile-accordion-filters-controls');
    filterRows.forEach(row => {
        const appliedValue = row.querySelector('.mobile-accordion-applied-filters');
        if (appliedValue) {
            appliedValue.value = '';
        }
        row.style.display = 'none';
    });
}

// Applies all filters and loads the page
function applyAllFilters() {

    clearFilterTags();

    var params = getURLParams();

    const filterButtons = document.querySelectorAll('.filter-apply-button');
    filterButtons.forEach(filterButton => {
        const toApply = filterButton.dataset.toApply;
        const filterType = filterButton.dataset.filterType;
        const filterKey = filterButton.dataset.filterKey;

        if (filterKey.length == 0) {
            console.error("Error applying filters, Invalid Filter Keys");
            return;
        }

        if (filterType == "rangeFilter") {
            const filterStep = filterButton.dataset.filterStep;
            var rangeFilters = applyRangeFilter(toApply, filterKey, filterStep, params);
            params['rangeFilters'] = rangeFilters;
        } else if (filterType == "listFilter") {
            var listFilters = applyListFilter(toApply, filterKey, params);
            params['listFilters'] = listFilters;
        } else {
            console.error("Error applying filters, Invalid Filter Type");
            return;
        }
        createFilterTags(params);
    });

    // Set page to 1
    params['page'] = 1;

    // Update url parameters
    updateURLParams(params);

    // Set the isFirstLoadMore flag as the initially loaded filtered products will have a cursor and clear the lastCursor
    isFirstLoadMore = false;
    lastCursor = null;

    loadMoreProducts(true);

    toggleDrawer();
}

function resetSortBy() {
    const sortBy = document.getElementById('mobile-sort-by-select');
    if(sortBy) {
        sortBy.selectedIndex = 0;
    }
}

// Apply filters and load the page
function applyFilters(e = false) {
    // Add loading symbol

    // Get current filters from url params
    var params = getURLParams();

    var isClearFilters = false;
    if (e) {
        e.preventDefault();
        const filterButton = e.target;

        if (filterButton.id == "mobile-sort-by-select") {
            params['sortBy'] = filterButton.value;
        } else if (filterButton.id == "mobile-clear-filters") {
            params = {};
            updateURLParams(params);
            resetFilterValues();
            resetSortBy();
            isClearFilters = true;
        } else if (filterButton.classList.contains('clear-single-mobile-filter')) {
            isClearFilters = true;
        } else {
            const toApply = filterButton.dataset.toApply;
            const filterType = filterButton.dataset.filterType;
            const filterKey = filterButton.dataset.filterKey;

            if (filterKey.length == 0) {
                console.error("Error applying filters, Invalid Filter Keys");
                return;
            }

            if (filterType == "rangeFilter") {
                const filterStep = filterButton.dataset.filterStep;
                params['rangeFilters'] = applyRangeFilter(toApply, filterKey, filterStep, params);
            } else if (filterType == "listFilter") {
                params['listFilters'] = applyListFilter(toApply, filterKey, params);
            } else {
                console.error("Error applying filters, Invalid Filter Type");
                return;
            }
            createFilterTags(params);
        }
    }

    // Set page to 1
    params['page'] = 1;

    // Update url parameters
    updateURLParams(params);

    // Set the isFirstLoadMore flag as the initially loaded filtered products will have a cursor and clear the lastCursor
    isFirstLoadMore = false;
    lastCursor = null;

    loadMoreProducts(true, false, isClearFilters);
}

function removeFilterRow(key) {
    const controls = document.getElementById(`applied-filters-controls-${key}`);
    if(controls) {
        controls.querySelector('.mobile-accordion-applied-filters').value = '';
        controls.style.display = 'none';
    }
}

function applyRangeFilter(toApply, key, filterStep, params) {
    var filterContainer = document.getElementById(toApply);
    var fromInput = filterContainer ? filterContainer.getElementsByClassName('fromInput')[0] || false : false;
    var toInput = filterContainer ? filterContainer.getElementsByClassName('toInput')[0] || false : false;

    var filters = params.rangeFilters || {};
    var filterKey = `${key}-${filterStep}`;

    if (fromInput && toInput) {
        // If the inputs aren't the default values apply the filter
        if (fromInput.value != fromInput.getAttribute('min') || toInput.value != toInput.getAttribute('max')) {
            if (filterKey) {
                filters[filterKey] = `${fromInput.value}-${toInput.value}`;
            }
        } else {
            if (filters[filterKey]) {
                delete filters[filterKey];
                removeFilterRow(key);
            }
        }
    }

    return filters;
}

function applyListFilter(toApply, filterKey, params) {

    var filters = params.listFilters || {};

    if (filterKey) {
        var checkedValues = getCheckedValues(toApply);

        if (checkedValues.length > 0) {
            filters[filterKey] = checkedValues;
        } else {
            delete filters[filterKey];
        }
    }

    return filters;
}

function getCheckedValues(formId) {
    const formElement = document.getElementById(formId);

    if(formElement) {
        const checkboxes = formElement.querySelectorAll('input[type="checkbox"]');

        const checkedValues = Array.from(checkboxes)
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.value);
    
        return checkedValues;
    }
    
    return [];
}

function findClosestStepDown(value, step) {
    return Math.floor(value / step) * step;
}

function findClosestStepUp(value, step) {
    return Math.ceil(value / step) * step;
}


function processFilters(params) {
    var processedFilters = [
        {
            "available": true
        }
    ];

    // Process the Range Filters 
    if (params.rangeFilters) {
        Object.entries(params.rangeFilters).forEach(([key, value]) => {

            const [filterKey, filterStep] = key.split('-');
            const [min, max] = value.split('-');

            const step = parseFloat(filterStep);

            // Create the filter object
            if (filterKey == "price") {
                const rangeFilter = {
                    [filterKey]: {
                        "min": parseFloat(min),  // "Greater than or equal to" filter
                        "max": parseFloat(max)   // "Lesser than or equal to" filter
                    }
                };
                processedFilters.push(rangeFilter);
            } else {
                const start = findClosestStepDown(min, step);
                const end = findClosestStepUp(max, step);

                for (let i = start; i <= end; i += step) {
                    const formattedValue = i.toFixed(4);

                    const rangeFilter = {
                        productMetafield: {
                            "namespace": "global",
                            "key": filterKey,
                            "value": formattedValue
                        }
                    };
                    processedFilters.push(rangeFilter);
                }
            }
        });
    }

    // Process the list filters
    if (params.listFilters) {
        Object.entries(params.listFilters).forEach(([key, values]) => {
            // Create the filter object
            values.forEach((val) => {
                const listFilter = {
                    [key]: val
                };

                processedFilters.push(listFilter);
            });
        });
    }

    return processedFilters;
}

// Handle the click event to prevent custom parameters from being overridden
function loadMoreClicked(e) {
    e.preventDefault();

    // Load additional products
    loadMoreProducts();
}

function loadMoreProducts(clearList = false, loadAllPages = false, isClearFilters = false) {
    var params = getURLParams();

    var productsToLoad = isFirstLoadMore ? productsPerPage * 2 : productsPerPage;
    var skeletonsToLoad = productsPerPage;

    // If this is the first time the load more button has been clicked during this page session we always want to set the page to 2
    // Otherwise if this isn't the first click, increment the page number 
    if (!clearList) {
        params.page = isFirstLoadMore ? 2 : parseInt(params.page) + 1 || 2;
    } else {
        // Clear loaded products handles as we have cycled through the originally loaded products so if a filter/sort is applied we want to show those orignal products
        if (loadedProductHandles.length > 0) {
            loadedProductHandles.splice(0, loadedProductHandles.length);
        }
        if (loadAllPages) {
            var currentPage = params.page ? params.page : 1;
            productsToLoad = Math.min(productsPerPage * currentPage, 250);
            // skeletonsToLoad = Math.min(skeletonsToLoad * currentPage, 250);
        }
    }

    if(!loadAllPages) {
        createProductCardSkeletons(skeletonsToLoad);
    }

    // If the sortBy parameter is set we want to use that ordering unless it's manual. If it's manual, the client wants to always prioritize new products.
    // If the sortBy parameter is not set, we want to also prioritize new products in the sort order
    // If we are clearing the filters/sort then we want to put it back to the default, manual sort order
    var sortBy = params['sortBy'] || 'CREATED_true';
    if (isClearFilters) {
        if (!params['sortBy'] && !params['listFilters'] && !params['rangeFilters']) {
            sortBy = 'MANUAL_false';
        }
        toggleDrawer();
    }

    if (sortBy == 'MANUAL_false' && !params['sortBy'] && (params['listFilters'] || params['rangeFilters'])) {
        sortBy = 'CREATED_true';
    }

    // // If there are no filters applied, and the sortBy isn't set, we want to maintian the manual sort
    if (!params['sortBy'] && !params['listFilters'] && !params['rangeFilters']) {
        sortBy = 'MANUAL_false';
    }

    const [sortKey, reverseString] = sortBy.split('_');
    const reverse = reverseString === 'true' ? true : false;

    const filters = processFilters(params);
    const hasFilters = filters.length > 1 ? true : false;

    const variables = {
        first: productsToLoad,
        after: lastCursor,
        filters: filters,
        handle: currentCollectionHandle,
        sortKey: sortKey,
        reverse: reverse
    };
        
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '54e3dff3abd9389617babac443139f3d'
        },
        body: JSON.stringify({
            query: QUERY,
            variables
        })
    };

    fetch('https://lumbershack.myshopify.com/api/2025-01/graphql.json', options)
        .then(response => response.json())
        .then(data => {

            if (data.errors && data.errors.length > 0) {
                console.error(data);
                return;
            }

            if (clearList) {
                var container = document.getElementById('product-cards-container');
                if(container) {
                    container.innerHTML = '';
                }
            }

            // Check to see if there are any more pages; if not, hide the 'Load More Products' button; otherwise, show it.
            hasNextPage = data?.data?.collection?.products?.pageInfo?.hasNextPage ?? false;
            
            var loadMoreProducts = document.getElementById('load-more-products');
            if(loadMoreProducts) {
                if (!hasNextPage) {
                    loadMoreProducts.style.display = 'none';
                } else {
                    loadMoreProducts.style.display = 'unset';
                }
            }

            // Get the product edges from the returned data
            var edges = data.data.collection.products.edges;

            // If this is the first time load more is called and there are no filters applied, filter out the originially loaded products
            // Since we load the first set of products server side, we need to filter them out on the first load more call to ensure there are no duplicates.
            // If there are filters applied, that means all products have been loaded through js and not server side, so there is no need to filter out those products
            if (isFirstLoadMore) {
                edges = edges.filter((product) => {
                    return !loadedProductHandles.includes(product.node.handle);
                });
                isFirstLoadMore = false;
            }

            // Update the cursor so subsequent calls always load the next set of products rather than reloading already displayed products
            if (edges.length > 0) {
                lastCursor = edges[edges.length - 1].cursor;
            }

            // Process the graphql data and build the associated product cards
            products = processProductData(edges);

            // Remove the skeletons
            removeProductSkeletons();

            // Render product cards
            renderProductCards(products);

            // Update current page number
            updateURLParams(params);

            // Update the add to compare status of the new products
            checkAddToCompareStatus();

            // Update product count/ message text
            var totalProducts = document.querySelector('.total-products');
            if(totalProducts) {
                if(hasFilters) { 

                    // get all elements with class card--holder
                    var productCards = document.querySelectorAll('.card--holder');  

                    if(hasNextPage || productCards.length > 0) {
                        totalProducts.innerHTML = `If you do not see what you are looking for in this filtered search, please widen your search dimensions and/or wood type and search again. You can also chat or call in during normal business hours, or contact us for a personalized experience. One of our wood experts will get in touch with you with some options that may be available.`;
                    } else {
                        totalProducts.innerHTML = `We're sorry, we do not have any products currently available within those filtered ranges. Please widen your search dimensions and/or wood type and search again. You can also chat or call in during normal business hours, or contact us for a personalized experience. One of our wood experts will get in touch with you with some options that may be available.`;
                    }
                } else {
                    // get data-count from totalProducts
                    var count = totalProducts.dataset.count || 0;

                    totalProducts.innerHTML = `${count} products in this collection`;
                }
            }
        })
        .catch(error => {
            console.error('Error fetching products: ', error);
        });

}

function createProductCardSkeletons(productsToLoad) {
    
    const productList = document.querySelector('.product-cards-container');

    var skeletons = "";
    for(let i = 0; i < productsToLoad; i++) {
        skeletons += `
        <div class="center col-6 col-md-3 card--holder">
            <div class="card--default__container product-card-skeleton">
                <div class="card--default card--noButton">
                    <a class="card__img--container" href="">
                        <div class="card__img--ratio">
                            <div class="card__img">
                            </div>
                        </div>
                    </a>
                    <button class="product-compare__button" data-is-compared="false" data-product-handle="" onClick="toggleCompare(this)"></button>
                </div>
                <div class="product-card__text">
                    <a class="card__title" href="#">
                    </a>
                    <div class="card-dimensions-container"></div>
                    <span class="card__price">
                        <span class="jsPrice"></span>
                        <span class="card__price--old jsPrice">
                        </span>
                    </span>
                    <div class="product-card__buttons">
                        <a class="button--primary__filled product-card__button" href="#">View Product Details</a>
                    </div>
                </div>
            </div>
        </div>`;
    } 


    productList.innerHTML += skeletons;
}

function removeProductSkeletons() {
    document.querySelectorAll('.product-card-skeleton').forEach(element => element.remove());
}

// Process the graphQL data and return an array of its built cards
function processProductData(edges) {
    var cards = [];

    edges.forEach((edge) => {

        var images = edge.node.images.edges;
        var frontImage = null;
        var backImage = null;

        if (images.length > 0) {
            frontImage = {
                src: images[0].node.originalSrc,
                alt: images[0].node.altText
            };
        }

        var backImageIndex = -1;
        if (images.length > 1) {
            backImageIndex = images.length > 3 ? 3 : 1;
            backImage = {
                src: images[backImageIndex].node.originalSrc,
                alt: images[backImageIndex].node.alt
            };
        }

        var dimensionsAttributes = [];
        try {
            dimensionsAttributes = edge.node.metafield ? JSON.parse(edge.node.metafield.value) : [];
        } catch (e) { 
            dimensionsAttributes = [];
        }

        var product = {
            title: edge.node.title,
            handle: edge.node.handle,
            url: edge.node.onlineStoreUrl,
            price: edge.node.variants?.edges[0]?.node?.priceV2?.amount || -1,
            compareAtPrice: edge.node.variants?.edges[0]?.node?.compareAtPriceV2?.amount || -1,
            frontImage: frontImage,
            backImage: backImage,
            available: false,
            type: edge.node.productType,
            dimensionsAttributes: dimensionsAttributes
        };

        var productCard = buildProductCard(product);

        cards.push(productCard);
    });

    return cards;
}

function getProductDimensions(dimensionsAttributes) { 

    let thinnestThickness = Infinity;
    let thickestThickness = 0;
    let narrowestWidth = Infinity;
    let widestWidth = 0;
    let tableTopNarrowestWidth = Infinity;
    let tableTopWidestWidth = 0;
    let shortestLength = Infinity;
    let longestLength = 0;
    let narrowestDiameter = Infinity;
    let widestDiameter = 0;

    let isRound = false;
    let isTableTop = false;

    dimensionsAttributes.forEach(item => {
        // Thickness Range
        if (item.thickness && item.thickness.status === '1') {
            const thickness = Number(item.thickness.value);
            if (thickness > thickestThickness) {
                thickestThickness = thickness;
            }
            if (thickness < thinnestThickness && thickness > 0) {
                thinnestThickness = thickness;
            }
        }

        // Width Range
        if (item.widest_width && item.widest_width.status === '1') {
            const widestWidthValue = Number(item.widest_width.value);
            if (widestWidthValue > widestWidth) {
                widestWidth = widestWidthValue;
            }
        }

        if (item.narrowest_width && item.narrowest_width.status === '1') {
            const narrowestWidthValue = Number(item.narrowest_width.value);
            if (narrowestWidthValue < narrowestWidth && narrowestWidthValue > 0) {
                narrowestWidth = narrowestWidthValue;
            }
        }

        // Table Top Width Range
        if (item.table_top_widest_width && item.table_top_widest_width.status === '1') {
            const tableTopWidestWidthValue = Number(item.table_top_widest_width.value);
            if (tableTopWidestWidthValue > tableTopWidestWidth) {
                tableTopWidestWidth = tableTopWidestWidthValue;
            }
        }

        if (item.table_top_narrowest_width && item.table_top_narrowest_width.status === '1') {
            const tableTopNarrowestWidthValue = Number(item.table_top_narrowest_width.value);
            if (tableTopNarrowestWidthValue < tableTopNarrowestWidth && tableTopNarrowestWidthValue > 0) {
                tableTopNarrowestWidth = tableTopNarrowestWidthValue;
            }
        }

        // Length Range
        if (item.longest_length && item.longest_length.status === '1') {
            const longestLengthValue = Number(item.longest_length.value);
            if (longestLengthValue > longestLength) {
                longestLength = longestLengthValue;
            }
            if (longestLengthValue < shortestLength && longestLengthValue > 0) {
                shortestLength = longestLengthValue;
            }
        }

        // Diameter Range
        if (item.widest_diameter && item.widest_diameter.status === '1') {
            const widestDiameterValue = Number(item.widest_diameter.value);
            if (widestDiameterValue > widestDiameter) {
                widestDiameter = widestDiameterValue;
            }
        }

        if (item.narrowest_diameter && item.narrowest_diameter.status === '1') {
            const narrowestDiameterValue = Number(item.narrowest_diameter.value);
            if (narrowestDiameterValue < narrowestDiameter && narrowestDiameterValue > 0) {
                narrowestDiameter = narrowestDiameterValue;
            }
        }
    });

    // Calculate ranges
    let thickness = `${thinnestThickness}" - ${thickestThickness}"`;
    if (thinnestThickness === thickestThickness) {
        thickness = `${thinnestThickness}"`;
    } else if (thinnestThickness === Infinity) {
        thickness = `${thickestThickness}"`;
    } else if (thickestThickness === 0) {
        thickness = `${thinnestThickness}"`;
    }

    let width = `${narrowestWidth}" - ${widestWidth}"`;
    if (narrowestWidth === widestWidth) {
        width = `${narrowestWidth}"`;
    } else if (narrowestWidth === Infinity) {
        width = `${widestWidth}"`;
    } else if (widestWidth === 0) {
        width = `${narrowestWidth}"`;
    }

    let tableTopWidth = `${tableTopNarrowestWidth}" - ${tableTopWidestWidth}"`;
    if (tableTopNarrowestWidth === tableTopWidestWidth) {
        tableTopWidth = `${tableTopNarrowestWidth}"`;
    } else if (tableTopNarrowestWidth === Infinity) {
        tableTopWidth = `${tableTopWidestWidth}"`;
    } else if (tableTopWidestWidth === 0) {
        tableTopWidth = `${tableTopNarrowestWidth}"`;
    }

    let length = `${shortestLength}" - ${longestLength}"`;
    if (shortestLength === longestLength) {
        length = `${shortestLength}"`;
    } else if (shortestLength === Infinity) {
        length = `${longestLength}"`;
    } else if (longestLength === 0) {
        length = `${shortestLength}"`;
    }

    let diameter = `${narrowestDiameter}" - ${widestDiameter}"`;
    if (narrowestDiameter === widestDiameter) {
        diameter = `${narrowestDiameter}"`;
    } else if (narrowestDiameter === Infinity) {
        diameter = `${widestDiameter}"`;
    } else if (widestDiameter === 0) {
        diameter = `${narrowestDiameter}"`;
    }

    // Determine if the product is round
    if (widestDiameter > 0 || narrowestDiameter < Infinity) {
        isRound = true;
    }

    // Determine if the product is a table top
    if (tableTopWidestWidth > 0 || tableTopNarrowestWidth < Infinity) {
        isTableTop = true;
    }

    if(thickness.includes('0"') && (width.includes('0"') || tableTopWidth.includes('0"')) && length.includes('0"') && diameter.includes('0"')) { 
        return '<div class="card-dimensions-container"><div class="card-dimensions"></div></div>';
    }

    // Output results
    const dimensions = `
    <div class="card-dimensions-container">
      <div class="card-dimensions">
        <span class="dimensions-label">Thickness:</span>
        <span class="dimensions-value">${thickness}</span>
      </div>
      ${isRound ? `
        <div class="custom-build-dimensions">
          <span class="dimensions-label">Diameter:</span>
          <span class="dimensions-value">${diameter}</span>
        </div>
      ` : `
        <div class="custom-build-dimensions">
          <span class="dimensions-label">Width:</span>
          <span class="dimensions-value">${isTableTop ? tableTopWidth : width}</span>
        </div>
        <div class="custom-build-dimensions">
          <span class="dimensions-label">Length:</span>
          <span class="dimensions-value">${length}</span>
        </div>
      `}
    </div>
    `;

    return dimensions;
}

function buildProductCard(product) {
    let card = "";
    let percentOff = 0;
    const price = parseFloat(product.price);
    const compareAtPrice = parseFloat(product.compareAtPrice);
    const onSale = compareAtPrice > 0;

    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const formattedPrice = USDollar.format(price);
    const formattedCompareAtPrice = USDollar.format(compareAtPrice);

    const productDimensions = getProductDimensions(product.dimensionsAttributes);

    card += `
    <div class="center col-6 col-md-3 card--holder">
        <div class="card--default__container">
            <div class="card--default card--noButton">
                <a class="card__img--container" href="${product.url}">
                    <div class="card__img--ratio">
                        <div class="card__img">
                            <!-- Sale/Sold out tag -->
                            <div class="card__tags">`;
    if (compareAtPrice > price) {
        percentOff = Math.round(Math.abs((compareAtPrice - price) * 100 / compareAtPrice));
        card += `<span class="tag tag--sale">${percentOff}% Off</span>`;
    } 

    card += `</div>`;

    if (product.frontImage) {
        card += `<img src="${product.frontImage.src}" alt="${product.title} Front Image" data-default-src="${product.frontImage.src}" loading="lazy" class="lazyloaded"/>`;
    }

    if (product.backImage) {
        card += `<img src="${product.backImage.src}" alt="${product.title} Back Image" data-default-src="${product.backImage.src}" loading="lazy" class="lazyloaded card__img--secondary"/>`;
    }
    card += `
                        </div>
                    </div>
                </a>
                <button class="product-compare__button" data-is-compared="false" data-product-handle="${product.handle}" onClick="toggleCompare(this)"></button>
            </div>
            <div class="product-card__text">
                <a class="card__title" href="${product.url}">
                    ${product.title}
                </a>
                ${productDimensions}
                <span class="card__price`; if (onSale) { card += ` card__price--sale`; } card += `">
                    <span class="jsPrice">${formattedPrice} </span>`;
    if ((price < compareAtPrice) && onSale) {
        card += `<span class="card__price--old jsPrice">${formattedCompareAtPrice}</span>`;
    }
    card += `
                </span>
                <div class="product-card__buttons">
                    <a class="button--primary__filled product-card__button" href="${product.url}">View Product Details</a>
                </div>
            </div>
        </div>
    </div>`;

    return card;
}

function formatPrice(price) {
    const priceInDollars = price / 100;
    return "$" + priceInDollars.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function renderProductCards(productCards) {

    const productList = document.querySelector('.product-cards-container');

    const joinedCards = productCards.join(' ');

    productList.innerHTML += joinedCards;
}

function openFilterDrawer() {
    const filterDrawer = document.getElementById('mobileFilterDrawer');
    if(filterDrawer) {
        filterDrawer.style.display = "unset";
    }
}

function toggleDrawer() {
    const overlay = document.getElementById('drawerOverlay');
    const drawer = document.getElementById('mobileFilterDrawer');

    if(overlay && drawer) {
        overlay.classList.toggle('active');
        drawer.classList.toggle('active');
    }
}

function checkAddToCompareStatus() {
    // Initialize compare products status
    var compareProducts = [];
    if (localStorage.getItem('compare_products')) {
        compareProducts = JSON.parse(localStorage.getItem("compare_products"));
    }

    var productList = document.querySelector('.row--product-list');
    if (productList) {
        compareProducts.forEach((handle) => {
            var button = productList.querySelector(`button[data-product-handle='${handle}']`);
            if (button) {
                button.dataset.isCompared = "true";
                button.classList.add('product-compare__button-added');
            }
        });
    }
}

// On Page loaded
window.addEventListener('DOMContentLoaded', (event) => { 

    filterDropDownOpen = false;

    // Add click listeners to allow the filter tabs to be closed
    const filterTabs = document.querySelectorAll('.custom-mobile-accordion-control');
    filterTabs.forEach(tab => {
        tab.addEventListener('click', function (event) {

            const isChecked = this.getAttribute('data-is-checked') === 'true';

            filterTabs.forEach(otherTab => {
                otherTab.setAttribute('data-is-checked', 'false');
            });

            if (isChecked) {
                this.checked = false;
                this.setAttribute('data-is-checked', 'false');
            } else {
                this.checked = true;
                this.setAttribute('data-is-checked', 'true');
            }
        });
    });

    // Initialize all sliders on the page
    const sliderContainers = document.querySelectorAll('.slider-container');
    sliderContainers.forEach(sliderContainer => {
        initializeSlider(sliderContainer);
    });

    // Initialize all apply filter buttons
    const applyFilterButtons = document.querySelectorAll('.filter-apply-button');
    applyFilterButtons.forEach(applyFilterButton => {
        applyFilterButton.addEventListener('click', function (event) {
            applyFilters(event);
        });
    });

    // Initialize apply all filters button
    const showResultsButton = document.getElementById('show-results');
    if(showResultsButton) {
        showResultsButton.addEventListener('click', applyAllFilters);
    }

    // Initialize load more link
    const loadMore = document.querySelector('#load-more-products');
    if(loadMore) {
        loadMore.addEventListener('click', loadMoreClicked);
    }

    // Initialize mobile sortBy select
    const mobileSortBy = document.getElementById('mobile-sort-by-select');
    if(mobileSortBy) {
        mobileSortBy.addEventListener('change', applyFilters);
    }

    // Initialize mobile filter button
    const mobileFilterButton = document.getElementById('mobile-filter-button');
    if(mobileFilterButton) {
        mobileFilterButton.addEventListener('click', toggleDrawer);
    }

    // Initialize overlay
    const overlay = document.getElementById('drawerOverlay');
    if(overlay) {
        overlay.addEventListener('click', toggleDrawer);
    }

    // Initialize clear filters button
    const clearMobileFilters = document.getElementById('mobile-clear-filters');
    if(clearMobileFilters) {
        clearMobileFilters.addEventListener('click', applyFilters);
    }

    // Initialize clear mobile filtler buttons 
    const clearMobileFilterButtons = document.querySelectorAll('.clear-single-mobile-filter');
    clearMobileFilterButtons.forEach(clearFilter => {
        clearFilter.addEventListener('click', clearMobileFilter);
    });

    // Initialize the filter input auto highlight functionality
    const filterInputs = document.querySelectorAll('.filterInput');
    filterInputs.forEach(input => {
        input.addEventListener('focus', function () {
            this.select();
        });
    });

    var params = getURLParams();
    if (params['sortBy']) {
        for (var i = 0; i < mobileSortBy.options.length; i++) {
            if (mobileSortBy.options[i].value === params['sortBy']) {
                mobileSortBy.selectedIndex = i;
                break;
            }
        }
    }

    checkAddToCompareStatus();
});

// Non DOM related setup
(function () {

    var params = getURLParams();

    if (params['listFilters'] || params['rangeFilters']) {
        createFilterTags(params);
        setFilterValues(params);
        loadMoreProducts(true, true);
    } else if (params['page'] && params['page'] > 1) {
        loadMoreProducts(true, true);
    }
})();
